import FormattedMessage from 'I18n/components/FormattedMessage';
import { useEffect } from 'react';
import { H4 } from 'foundations-components/transitional/components/H4';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { Box } from 'foundations-components/transitional/components/Box';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { NavMarker } from 'react-rhumb';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import { Button } from 'foundations-components/transitional/components/Button';
import { useGlobalHomeEligibility } from 'setup-guide-api/dataFetchingClient/queries/globalHomeEligibility';
import { trackPageView } from '../../utils/usageTracker';
import { redirectToGlobalHome } from '../../utils/urls';
import { CHANGE_DEFAULT_HOMEPAGE_ROUTE } from '../../constants/routeConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ViewOnlySeatErrorPage() {
  const {
    isEligibleForGlobalHome,
    hasGlobalHomeError
  } = useGlobalHomeEligibility();
  const shouldRedirectToGlobalHome = isEligibleForGlobalHome || hasGlobalHomeError;
  useEffect(() => {
    trackPageView('view only seat error page');
  }, []);
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    "data-test-id": "view-only-seat-error",
    direction: "row",
    justify: "center",
    wrap: "wrap",
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "VIEW_ONLY_SEAT_ERROR_SCREEN"
    }), /*#__PURE__*/_jsx(Box, {
      basis: 700,
      children: /*#__PURE__*/_jsxs(ErrorMessage, {
        illustration: "keys",
        title: /*#__PURE__*/_jsx(H4, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.error.seats.readOnlySeat.title"
          })
        }),
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.error.seats.readOnlySeat.description"
          })
        }), shouldRedirectToGlobalHome ? /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(Button, {
            "data-test-id": "go-to-global-home-cta",
            onClick: () => {
              redirectToGlobalHome();
            },
            use: "primary",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.error.seats.readOnlySeat.goToGlobalHomeCTA"
            })
          })
        }) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.error.seats.readOnlySeat.alternateDescription"
            })
          }), /*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(UIRouterButton, {
              "data-test-id": "change-homepage-cta",
              to: CHANGE_DEFAULT_HOMEPAGE_ROUTE,
              use: "primary",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "app.error.seats.readOnlySeat.setYourHomepageCTA"
              })
            })
          })]
        })]
      })
    })]
  });
}